import axios from '@/utils/axios'
import {business, tenantUserPrefix} from '@/api/common'
import {getUrlPrefixByRole} from '@/utils/role'

/**
 * 医生信息列表
 * @param params
 */
export const tenantDoctorTable = (params, clinicCode) => {
  return axios({
    url: `${business}${getUrlPrefixByRole()}/tenant/doctor/${clinicCode}/tenantDoctorTable`,
    method: 'post',
    data: params
  })
}

/**
 * 获取当前租户所以医生列表
 * @param params
 */
export const tenantDoctorList = (params, clinicCode) => {
  return axios({
    url: `${business}${getUrlPrefixByRole()}/tenant/doctor/tenantDoctorList`,
    method: 'post',
    data: params,
    params: {clinicCode}
  })
}

/**
 * 获取医生完整信息
 */
export const getFullDoctorInfo = userCode => {
  return axios({
    url: `${business}${getUrlPrefixByRole()}/tenant/doctor/getFullDoctorInfo`,
    method: 'get',
    params: {userCode}
  })
}

/**
 * 修改医生信息
 * @param form
 */
export const editTenantDoctor = form => {
  return axios({
    url: `${business}${getUrlPrefixByRole()}/tenant/doctor/editTenantDoctor`,
    method: 'post',
    data: form
  })
}

/**
 * 添加医生信息
 * @param form
 */
export const addTenantDoctor = form => {
  return axios({
    url: `${business}${getUrlPrefixByRole()}/tenant/doctor/addTenantDoctor`,
    method: 'post',
    data: form
  })
}

/**
 * 删除医生信息
 * @param userCodes 用户编码串
 */
export const removeTenantDoctor = (userCodes) => {
  return axios({
    url: `${business}${tenantUserPrefix}/tenant/doctor/removeTenantDoctor`,
    method: 'delete',
    params: {userCodes}
  })
}

/**
 * 关联诊所到医生
 */
export const addClinic2Doctor = (userCode, clinicCode) => {
  return axios({
    url: `${business}${getUrlPrefixByRole()}/tenant/doctor/addClinic2Doctor`,
    method: 'post',
    params: {userCode, clinicCode}
  })
}

/**
 * 删除医生关联的诊所
 */
export const removeClinicFromDoctor = (userCode, clinicCodes) => {
  return axios({
    url: `${business}${getUrlPrefixByRole()}/tenant/doctor/removeClinicFromDoctor`,
    method: 'delete',
    params: {userCode, clinicCodes}
  })
}



// WEBPACK FOOTER //
// ./src/api/business/tenantUser/doctor.js